import React from "react";
import Loader from "components/Loader";
import Insurance from "./insuranceUpdate";


const TransactionStageSelector = ({ data }) => {
  const [showLoader, setShowLoader] = React.useState(false);

  function setLoader(value) {
    setShowLoader(value);
  }
  if (showLoader) return <Loader />;

  if (data.transactionStatus === null || data.transactionStatus === undefined)
    return <div>Error</div>;

  if (data.transactionStatus === "RTO_COMPLETED") {
    return <Insurance data={data} setLoader={setLoader} />;
  }

  if (data.transactionStatus === "COMPLETED") {
    return <div>Insurance Process Completed</div>;
  }

  return <div>Error</div>;
};

export default TransactionStageSelector;
